import React from "react";
import {useDispatch} from "react-redux";
import Button from "../../components/Button";
import {requestChangeReplacementReason} from "../../actions/ShippingApiActions";
import {formatReplacementReason} from "../forms/ReplacePackagesForShippingOrderForm";


export function OrderReplacementReason(props) {
  const {
    className,
    orderId,
    replacedPackage,
  } = props;

  const dispatch = useDispatch();
  const reason = replacedPackage.get("reason");

  const handleSetReason = () => {
    dispatch(requestChangeReplacementReason(orderId, [replacedPackage.get("packageId")], reason));
  }

  if (!reason) {
    return <Button className={className} label="Set Replacement Reason" primary={true} onClick={handleSetReason} />;
  }

  return (
    <>Reason:&nbsp;<i>{formatReplacementReason(reason)}</i> <Button className={className} label="Change Replacement Reason" primary={false} onClick={handleSetReason} /></>
  );
}